<template>
	<div>
		<b-container fluid class="margin-top-header">
			<h1 class="p-5 text-center">Traslado de Vehículos</h1>
			<v-section-header>
				<b-col cols="12" md="10" offset-md="1" > 
					<b-row>
						<b-col cols="12" md="6">
							<b-form-group id="name" label="Nombres">
							<b-form-input v-model.trim="$v.solicitude.name.$model" :state="$v.solicitude.name.$dirty ? !$v.solicitude.name.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El nombre debe contener al menos {{$v.solicitude.name.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="name" label="Apellido Paterno">
								<b-form-input v-model.trim="$v.solicitude.lastnameFather.$model" :state="$v.solicitude.lastnameFather.$dirty ? !$v.solicitude.lastnameFather.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El apellido paterno debe contener al menos {{$v.solicitude.lastnameFather.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="name" label="Apellido Materno">
								<b-form-input v-model.trim="$v.solicitude.lastnameMother.$model" :state="$v.solicitude.lastnameMother.$dirty ? !$v.solicitude.lastnameMother.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El apellido materno debe contener al menos {{$v.solicitude.lastnameMother.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="rut" label="Rut">
								<b-form-input v-model.trim="$v.solicitude.rut.$model" :state="$v.solicitude.rut.$dirty ? !$v.solicitude.rut.$error : null" @keyup="formatRut"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Rut Inválido.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Celular">
								<b-row>
									<b-col cols="3">
										<b-form-select  v-model.trim="phones.selected" :options="phones.region" ></b-form-select>
									</b-col>
									<b-col>		
										<b-form-input v-model="$v.solicitude.phone.$model" :state="$v.solicitude.phone.$dirty ? !$v.solicitude.phone.$error : null"></b-form-input>
										<b-form-invalid-feedback id="input-1-live-feedback">
											El Celular debe contener al menos {{$v.solicitude.phone.$params.minLength.min}} números.
										</b-form-invalid-feedback>
									</b-col>
								</b-row>
							</b-form-group>
							<b-form-group id="name" label="Email">
								<b-form-input v-model.trim="$v.solicitude.email.$model" :state="$v.solicitude.email.$dirty ? !$v.solicitude.email.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Email inválido.
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<b-col cols-md="6">
							<b-form-group label="Region" :invalid-feedback="invalidFeedback" :valid-feedback="validFeedback" :state="state">
								<b-form-select v-model.trim="$v.solicitude.region_id.$model" :options="regions" :state="$v.solicitude.region_id.$dirty ? !$v.solicitude.region_id.$error : null">
									<template slot="first">
										<option :value="null" disabled>Seleccione Region</option>
									</template>
								</b-form-select>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Debes ingresar Region.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Comuna" :invalid-feedback="invalidFeedback" :valid-feedback="validFeedback" :state="state">
								<b-form-select v-model.trim="$v.solicitude.commune_id.$model" :options="communes" :state="$v.solicitude.commune_id.$dirty ? !$v.solicitude.commune_id.$error : null" >
									<template slot="first">
										<option :value="null" disabled>Seleccione Comuna</option>
									</template>
								</b-form-select>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Debes ingresar Region.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Dirección">
								<b-form-input v-model.trim="$v.solicitude.address.$model" :state="$v.solicitude.address.$dirty ? !$v.solicitude.address.$error : null" ></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Debes Ingresar Dirección
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Referencia">
								<b-form-input v-model.trim="$v.solicitude.reference.$model" :state="$v.solicitude.reference.$dirty ? !$v.solicitude.reference.$error : null" ></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									La referencia debe tener al menos {{$v.solicitude.reference.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Nombre de contacto">
								<b-form-input v-model.trim="$v.solicitude.name_contact.$model" :state="$v.solicitude.name_contact.$dirty ? !$v.solicitude.name_contact.$error : null" ></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El nombre de contacto debe tener al menos {{$v.solicitude.name_contact.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Teléfono de contacto">
								<b-row>
									<b-col cols="3">
										<b-form-select  v-model.trim="phones.selected_contact" :options="phones.contact" ></b-form-select>
									</b-col>
									<b-col>		
										<b-form-input v-model.trim="$v.solicitude.phone_contact.$model" :state="$v.solicitude.phone_contact.$dirty ? !$v.solicitude.phone_contact.$error : null" ></b-form-input>
										<b-form-invalid-feedback id="input-1-live-feedback">
											El teléfono debe tener al menos {{$v.solicitude.phone_contact.$params.minLength.min}} números.
										</b-form-invalid-feedback>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col v-if="loading" cols="12" class="text-center mt-5">
							<grid-loader :color="color"></grid-loader>
						</b-col>
						<b-col cols="12" v-if="this.error.message">
							<b-alert class="text-center" variant="danger" show>{{ error.message }}</b-alert>
						</b-col>
						<b-col cols="12" class="text-center">
							<b-button squared size="lg" class=" mt-5 pl-5 pr-5" variant="outline-macal" @click="send" >¡Solicitar!</b-button>
						</b-col>
					</b-row>
				</b-col>
			</v-section-header>
		</b-container>
	</div>
</template>
<script>
  import SectionHeader from "../../../components/section-header";
  import { required, minLength, numeric, email } from "vuelidate/lib/validators";
  import { isRutValid } from "@/validators";

  export default {
    name: 'financing',
    components: {
		'v-section-header': SectionHeader,
	},
	props: {
		car_id: {default: null},
		simulation: {
			cae: {default: null},
			total: {default: null},
			amount: {default: null},
			due: {default: null}
		}
	},
	data (){
		return{
			amount: "",
			due: 60,
			loading: false,
            color: "#E4610C",
			solicitude: {
				rut: null,
				name: null,
				lastnameFather: null,
				lastnameMother: null,
				address: null,
				phone: null,
				email: null,
				region_id: null,
				commune_id: null,
				name_contact: null,
				phone_contact: null,
                reference: null
            },
			error: {
				solicitude: {
					rut: [],
					email: []
				},
				message: ""
			},
			phones:{
				region: [
						{value: "+56", text: "+56"}, {value: "+32", text: "+32"}, {value: "+33", text: "+33"}, {value: "+34", text: "+34"}, {value: "+35", text: "+35"}, {value: "+39", text: "+39"},
						{value: "+41", text: "+41"}, {value: "+42", text: "+42"}, {value: "+43", text: "+43"}, {value: "+44", text: "+44"}, {value: "+45", text: "+45"}, {value: "+51", text: "+51"},
						{value: "+52", text: "+52"}, {value: "+53", text: "+53"}, {value: "+55", text: "+55"}, {value: "+57", text: "+57"}, {value: "+58", text: "+58"}, {value: "+61", text: "+61"},
						{value: "+63", text: "+63"}, {value: "+64", text: "+64"}, {value: "+65", text: "+65"}, {value: "+67", text: "+67"}, {value: "+71", text: "+71"}, {value: "+73", text: "+71"},
						{value: "+75", text: "+75"}
				],
				contact: [
						{value: "+56", text: "+56"}, {value: "+32", text: "+32"}, {value: "+33", text: "+33"}, {value: "+34", text: "+34"}, {value: "+35", text: "+35"}, {value: "+39", text: "+39"},
						{value: "+41", text: "+41"}, {value: "+42", text: "+42"}, {value: "+43", text: "+43"}, {value: "+44", text: "+44"}, {value: "+45", text: "+45"}, {value: "+51", text: "+51"},
						{value: "+52", text: "+52"}, {value: "+53", text: "+53"}, {value: "+55", text: "+55"}, {value: "+57", text: "+57"}, {value: "+58", text: "+58"}, {value: "+61", text: "+61"},
						{value: "+63", text: "+63"}, {value: "+64", text: "+64"}, {value: "+65", text: "+65"}, {value: "+67", text: "+67"}, {value: "+71", text: "+71"}, {value: "+73", text: "+71"},
						{value: "+75", text: "+75"},{value: "+2", text: "+2"}
				],
				selected: "+56",
				selected_contact: "+56"
			},
            regions:[],
            communes: [],
			state: null,
			invalidFeedback: null,
			validFeedback: null
		}
	},
	validations: {
		solicitude:{
			rut: { required, RutValid: isRutValid },
			name: { required, minLength: minLength(3) },
			lastnameFather: { required, minLength: minLength(3) },
			lastnameMother: { required, minLength: minLength(3) },
			phone: { required, numeric ,minLength: minLength(9) },
			email: { required, email },
			address: { required , minLength: minLength(6) },
			reference: {required, minLength: minLength(6)},
			name_contact: {required, minLength: minLength(3)},
			phone_contact: {required, numeric, minLength: minLength(9)},
			region_id: {required},
			commune_id: {required},
		}
    },
	mounted() {
        this.solicitude.amount = 1200;
		this.listRegions()
		this.send_count()
	},
	methods:{
		send_count(){
			this.axios.post("meters", {id: 212926, url: window.location.href, width: window.innerWidth, height: window.innerHeight}).then(() => {})
		},
        listRegions(){
			this.axios.get("transfers/regions").then(result => {
                this.regions = result.data.map(region => {return {text: region.RegDescripcion, value: region.RegId}})
            }).catch(() => {
				this.loading = false
            })
        },
        listCommune(){
			this.axios.get("transfers/communes", {params: {region_id: this.solicitude.region_id }} ).then(result => {
                this.communes = result.data.map(region => {return {text: region.ComDescripcion, value: region.ComId}})
            }).catch(() => {
				this.loading = false
            })
        },
		send(){
			this.$v.solicitude.$touch()
			if(!this.$v.solicitude.$invalid){
				this.loading = true
				this.axios.post("transfers", this.solicitude).then(() => {
					this.loading = false
					this.$router.push({ name: 'vehicles-transfer-success', params: {customer: this.solicitude, car_id: this.car_id }});
				}).catch(() => {
					this.loading = false
					this.error.message = "¡Ops, Hubo un error en el proceso!"
				})
			}
		},
		formatRut(){
			if(this.solicitude.rut.length > 0){
				this.solicitude.rut = this.solicitude.rut.replace(/[^\dKk]/g, '');
				let dato = this.solicitude.rut;
				let largo = dato.length;
				if (largo === 1) {
					this.dv = dato;
					this.solicitude.rut = '';
					this.digito(this.solicitude.rut, this.dv);
					this.formato()
				} else if (largo > 1) {
					this.dv = dato.substring(largo - 1);
					this.solicitude.rut = dato.substring(largo - 1, 0);
					this.digito(this.solicitude.rut, this.dv);
					this.formato()
				}
			}
		},
		digito(rut,dv) {
			let suma = 0;
			let multiplicador = 2;
			while(rut !== 0){
			if (multiplicador === 8) {
				multiplicador = 2;
			}
			suma += (rut % 10) * multiplicador;
			rut = Math.trunc(rut / 10);
			multiplicador++;
			}
			suma = 11 - (suma % 11);
			switch (suma) {
			case 11:
				this.check = ("0" === dv);
				break;
			case 10:
				this.check = ("K" === dv.toUpperCase());
				break;
			default:
				this.check = (suma.toString() === dv);
				break;
			}
		},
		formato() {
			let rut = (this.solicitude.rut) ? (new Intl.NumberFormat("es-CL").format(parseInt(this.solicitude.rut))) + '-' : '';
			this.solicitude.rut = rut + this.dv;
		},
	},
	watch: {
        "solicitude.region_id": {
            handler: function() {
                this.listCommune()
            }
        }
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>